import axios from "axios";
import { useEffect, useState } from "react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let token = sessionStorage.getItem("bss_token");
export const setToken = (t) => {
  token = t;
  if (t) sessionStorage.setItem("bss_token", t);
  else sessionStorage.removeItem("bss_token");
};

api.interceptors.request.use((cfg) => {
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const skip = cfg?.url?.includes("/auth/login") || cfg?.url?.includes("/auth/refresh");
    if (err.response?.status === 401 && cfg && !cfg._retry && !skip) {
      cfg._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        setToken(data?.access_token);
        return api(cfg);
      } catch (e) {
        setToken(null);
      }
    }
    return Promise.reject(err);
  }
);

export const mediaUrl = (src) => (!src ? "" : src.startsWith("/api/") ? `${BACKEND}${src}` : src);

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail?.msg || String(detail);
}

export function useFetch(path) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    api
      .get(path)
      .then((r) => alive && setState({ data: r.data, loading: false, error: null }))
      .catch((e) => alive && setState({ data: null, loading: false, error: e }));
    return () => {
      alive = false;
    };
  }, [path]);
  return state;
}

export const asList = (data) => (Array.isArray(data) ? data : []);
